import React from 'react'
import RightSide from '../components/common/rightSide';
import AboutUs from '../components/other/aboutUs';


const AboutUsPage = () => {
    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='row'>
                    {/* <div className='col-md-4'>
                        <RightSide />
                    </div> */}
                    <div className='col-md-12'>
                        <AboutUs />
                    </div>

                </div>
            </div>

        </>
    )
}

export default AboutUsPage;